import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Intro from "../../elements/blocks/intro";
import Controls from "../../elements/blocks/controls";
import ContactDetails from "../../elements/contacts/contact-details";
import ContactHistory from "../../elements/contacts/contact-history";
import TicketsMetrics from "../../elements/tickets/tickets-metrics";
import TicketsTable from "../../elements/tickets/tickets-table";
import TicketCampaignSelect from "../../elements/tickets/ticket-campaign-select";
import Nope from "../../elements/blocks/nope";
import { useApiTenant } from "../../../api/api-tenant";
import { useRoles } from "../../../services/roles";
export default function ContactView() {
    const { id } = useParams();
    return _jsx(ContactViewComponent, {}, id);
}
function ContactViewComponent() {
    const { t } = useTranslation();
    const { id } = useParams();
    const api = useApiTenant();
    const roles = useRoles();
    const [contact, setContact] = useState(null);
    const [tab, setTab] = useState("profile");
    const [isLoading, setIsLoading] = useState(true);
    const [newTicket, setNewTicket] = useState(false);
    useEffect(() => {
        setIsLoading(true);
        api.GET_contact(id)
            .then(response => {
            setContact(response.data.contact);
            setIsLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                setIsLoading(false);
            }
        });
        return () => api.cancel();
    }, [id]);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: contact
                    ? contact.type
                        ? contact.type === "business"
                            ? contact.company
                                ? contact.company
                                : contact.is_anonymous === true
                                    ? t("contacts.anonymous")
                                    : contact.first_name || contact.last_name
                                        ? (contact.first_name ? contact.first_name : "") +
                                            (contact.last_name ? " " + contact.last_name : "")
                                        : ""
                            : contact.is_anonymous === true
                                ? t("contacts.anonymous")
                                : contact.first_name || contact.last_name
                                    ? (contact.first_name ? contact.first_name : "") +
                                        (contact.last_name ? " " + contact.last_name : "")
                                    : contact.company
                                        ? contact.company
                                        : ""
                        : contact.company
                            ? contact.company
                            : contact.is_anonymous === true
                                ? t("contacts.anonymous")
                                : contact.first_name || contact.last_name
                                    ? (contact.first_name ? contact.first_name : "") +
                                        (contact.last_name ? " " + contact.last_name : "")
                                    : t("contacts.contact") + " #" + id
                    : t("contacts.contact") + " #" + id, breadcrumbs: [
                    {
                        name: t("contacts.contacts"),
                        link: "/contacts",
                    },
                    {
                        name: contact
                            ? contact.type
                                ? contact.type === "business"
                                    ? contact.company
                                        ? contact.company
                                        : contact.is_anonymous === true
                                            ? t("contacts.anonymous")
                                            : contact.first_name || contact.last_name
                                                ? (contact.first_name ? contact.first_name : "") +
                                                    (contact.last_name ? " " + contact.last_name : "")
                                                : ""
                                    : contact.is_anonymous === true
                                        ? t("contacts.anonymous")
                                        : contact.first_name || contact.last_name
                                            ? (contact.first_name ? contact.first_name : "") +
                                                (contact.last_name ? " " + contact.last_name : "")
                                            : contact.company
                                                ? contact.company
                                                : ""
                                : contact.company
                                    ? contact.company
                                    : contact.is_anonymous === true
                                        ? t("contacts.anonymous")
                                        : contact.first_name || contact.last_name
                                            ? (contact.first_name ? contact.first_name : "") +
                                                (contact.last_name ? " " + contact.last_name : "")
                                            : ""
                            : t("contacts.contact"),
                        link: "/contacts/" + id,
                    },
                ], button: contact
                    ? {
                        label: tab === "profile"
                            ? t("contacts.edit-contact")
                            : t("tickets.new-ticket"),
                        link: tab === "profile" ? "/contacts/" + id + "/edit" : undefined,
                        action: tab === "tickets" ? () => setNewTicket(true) : undefined,
                        color: tab === "profile" ? "primary" : "secondary",
                        type: tab === "profile" ? "edit" : "new",
                    }
                    : undefined, loading: isLoading }), isLoading ? (_jsx(Fragment, {})) : contact ? (_jsxs(Fragment, { children: [_jsx(Controls, { tabs: [
                            {
                                label: t("contacts.profile"),
                                value: "profile",
                            },
                            {
                                label: t("tickets.tickets"),
                                value: "tickets",
                            },
                        ], tab: tab, setTab: setTab }), tab === "profile" ? (_jsxs(Fragment, { children: [_jsx(ContactDetails, { type: "contact", contact: contact }), contact.history && contact.history.length > 0 && (_jsx(ContactHistory, { status: "view", contact: contact }))] })) : (_jsxs(Fragment, { children: [(roles.isManager || roles.isAdmin) && (_jsx(TicketsMetrics, { type: "contact", contact_id: contact.id })), _jsx(TicketsTable, { type: "contact", contact: contact }), _jsx(TicketCampaignSelect, { newTicket: newTicket, setNewTicket: setNewTicket, contact: contact })] }))] })) : (_jsx(Nope, { title: t("errors.404"), caption: t("contacts.errors.not-found") }))] }));
}
